import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useDatiEdizione, Caricamento, Errore } from './datiEdizione';
import NonTrovato from '../NonTrovato';
// Lo stile del link è quello dei componenti Link*, che su queste rotte non sono montati: senza
// questo import il breadcrumb mostrerebbe un link senza stile.
import '../../../components/statistiche/Link.css';
import '../Statistiche.css';

/**
 * La cornice di una edizione: il riepilogo e le sue viste sono rotte figlie di questa.
 *
 * Il layout esiste per il costo del dato. `statistiche.full` restituisce l'edizione intera —
 * tutte le squadre, tutti i giocatori con le loro statistiche, tutte le partite con i referti di
 * entrambe le formazioni — e finché le viste erano rotte sorelle ognuna la riscaricava montando.
 * Passare da «Squadre» a «Giocatori» costava un download completo, che al telefono si sente.
 * Qui si carica una volta per tutta la permanenza sull'edizione, e le figlie leggono l'Outlet.
 *
 * Per lo stesso motivo salgono qui anche il breadcrumb e l'avviso sui dati parziali: valgono per
 * l'edizione, non per una sua vista, e chi arriva diretto su /squadre ha lo stesso bisogno di
 * risalire alle statistiche e di sapere che quei numeri sono di un torneo ancora in corso.
 *
 * L'avviso conta piu' di prima ora che l'archivio pubblico mostra anche le edizioni in corso: chi
 * arriva qui da fuori vede numeri veri ma provvisori, e deve sapere che cambieranno ancora.
 */
export default function EdizioneLayout() {
  const { idEdizione } = useParams();
  const { statistiche, loading, error, fuoriArchivio, ricarica } = useDatiEdizione(idEdizione);

  if (loading) return <Caricamento />;
  if (fuoriArchivio) return <NonTrovato cosa="Le statistiche di questa edizione" />;
  if (error || !statistiche) return <Errore messaggio={error} onRiprova={ricarica} />;

  return (
    <>
      {statistiche.stato === 'inCorso' && (
        <div className="statistiche-parziali-banner">
          <i className="fas fa-hourglass-half"></i>
          Dati parziali — torneo in corso
        </div>
      )}

      <Outlet context={{ statistiche, idEdizione, ricarica }} />
    </>
  );
}
